import { formatDate } from 'v3/utils/controlTowerDate';

const id = (value) => Number.isSafeInteger(value) && value > 0;
const text = (value) => typeof value === 'string' && Boolean(value.trim());
const optionalText = (value) => value === undefined || value === null || text(value);
const invalid = () => {
  throw new Error('Resposta de recusa inválida. Atualize a consulta.');
};
export const assetsOf = (candidate) => [candidate.vehicle, ...candidate.wagons];
export function reasonsResponse(response) {
  const seen = new Set();
  if (
    !Array.isArray(response?.data) ||
    response.data.some((reason) => {
      if (!text(reason?.code) || !text(reason.label) || seen.has(reason.code)) return true;
      seen.add(reason.code);
      return false;
    })
  )
    invalid();
  return response.data;
}
function checkEvent(event, context, asset, type = 'REFUSAL') {
  if (
    !id(event?.id) ||
    event.eventType !== type ||
    event.asset?.type !== asset.assetType ||
    event.asset.id !== asset.id ||
    !text(event.asset.plate) ||
    event.load?.id !== context.item.loadId ||
    event.load.kind !== context.item.type ||
    !id(event.actor?.id) ||
    !text(event.actor.name) ||
    formatDate(event.occurredAt) === 'Não informado' ||
    !text(event.refusalReason?.code) ||
    !text(event.refusalReason.text) ||
    // 5703: observação da recusa, opcional (null na reversão).
    !optionalText(event.refusalNote) ||
    ![
      'FROTA',
      'OURO',
      'AGREGADO_CARRETA_COOPER',
      'AGREGADO_CONJUNTO_COMPLETO',
      'TERCEIRO',
    ].includes(event.linkType) ||
    ![true, false, null].includes(event.corridor) ||
    (type === 'REFUSAL' ? event.originalRefusalId !== null : !id(event.originalRefusalId))
  )
    invalid();
  return event;
}
function checkState(state, context, asset) {
  if (typeof state?.active !== 'boolean' || (state.active && !state.event)) invalid();
  if (state.event !== null) checkEvent(state.event, context, asset);
  return state;
}
export function detailsResponse(response, context, asset) {
  if (
    response?.loadId !== context.item.loadId ||
    response.asset?.type !== asset.assetType ||
    response.asset.id !== asset.id
  )
    invalid();
  return { asset, ...checkState(response.refusal, context, asset) };
}
export function mutationResponse(response, context, asset, command) {
  const reverse = command.confirmed === true;
  const event = checkEvent(response?.event, context, asset, reverse ? 'REVERSAL' : 'REFUSAL');
  if (
    typeof response.replayed !== 'boolean' ||
    (reverse
      ? event.originalRefusalId !== command.refusalId || response.refreshCandidates !== true
      : event.refusalReason.code !== command.reasonCode ||
        (event.refusalNote ?? null) !== (command.note ?? null))
  )
    invalid();
  checkState(response.refusal, context, asset);
  return response;
}
